var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardXpRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 7.34667V10.66C2.83984 11.8733 2.83984 11.8733 3.98651 12.6467L7.13984 14.4667C7.61318 14.74 8.38651 14.74 8.85984 14.4667L12.0132 12.6467C13.1598 11.8733 13.1598 11.8733 13.1598 10.66V7.34667C13.1598 6.13333 13.1598 6.13333 12.0132 5.36L8.85984 3.54C8.38651 3.26667 7.61318 3.26667 7.13984 3.54L3.98651 5.36C2.83984 6.13333 2.83984 6.13333 2.83984 7.34667Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 5.08667V3.33333C11.6668 2 11.0002 1.33333 9.66683 1.33333H6.3335C5.00016 1.33333 4.3335 2 4.3335 3.33333V5.04",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42018 7.32667L8.80018 7.92C8.86018 8.01333 8.99351 8.10667 9.09351 8.13333L9.77351 8.30667C10.1935 8.41333 10.3068 8.77333 10.0335 9.10667L9.58685 9.64667C9.52018 9.73333 9.46685 9.88667 9.47351 9.99333L9.51351 10.6933C9.54018 11.1267 9.23351 11.3467 8.83351 11.1867L8.18018 10.9267C8.08018 10.8867 7.91351 10.8867 7.81351 10.9267L7.16018 11.1867C6.76018 11.3467 6.45351 11.12 6.48018 10.6933L6.52018 9.99333C6.52685 9.88667 6.47351 9.72667 6.40685 9.64667L5.96018 9.10667C5.68685 8.77333 5.80018 8.41333 6.22018 8.30667L6.90018 8.13333C7.00685 8.10667 7.14018 8.00667 7.19351 7.92L7.57351 7.32667C7.81351 6.96667 8.18685 6.96667 8.42018 7.32667Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardXpRed);
export default __webpack_public_path__ + "static/media/reward-xp-red.7143b536f822ea3fd51ba2c8f92651e2.svg";
export { ForwardRef as ReactComponent };